import _ from 'lodash';
import GatewayRouteConfig from './config/RouteConfig';
import Features from 'app-features';
import AccountService from '../gateway/services/AccountService';
import SubmissionService from '../gateway/services/SubmissionService';
import RenewalService from '../gateway/services/RenewalService';
import ActivityService from '../gateway/services/ActivityService';
import PolicyService from '../gateway/services/PolicyService';
import SearchService from '../gateway/services/SearchService';
import JobService from '../gateway/services/JobService';
import UserService from '../gateway/services/UserService';
import OrganizationService from '../gateway/services/OrganizationService';
import ProductService from '../gateway/services/ProductService';
import DocumentService from '../gateway/services/DocumentService';
import NewAccountService from '../gateway/services/NewAccountService';
import ServiceBoxInfoService from '../gateway/services/ServiceBoxInfoService';
import CancellationService from '../gateway/services/CancellationService';
import PolicyChangeService from '../gateway/services/PolicyChangeService';
import CommissionService from '../gateway/services/CommissionService';
import ContactService from './services/ContactService';
import ActivitySummary from '../gateway/directives/ActivitySummaryDirective/ActivitySummary';
import GatewayNotes from '../gateway/directives/GatewayNotes';
import GatewayDocuments from '../gateway/directives/GatewayDocuments';
import BackButton from '../gateway/directives/BackButton';
import JobSummary from '../gateway/directives/JobSummaryDirective/JobSummary';
import PolicySummary from '../gateway/directives/PolicySummaryDirective/PolicySummary';
import AddActivity from '../gateway/directives/AddActivityDirective/AddActivity';
import PolicyTransactions from '../gateway/directives/PolicyTransactionsDirective/PolicyTransactions';
import CancelPolicy from '../gateway/directives/CancelPolicyDirective/CancelPolicy';
import ChangePolicy from '../gateway/directives/ChangePolicyDirective/ChangePolicy';
import PolicyBillingSummary from '../gateway/directives/PolicyBillingSummaryDirective/PolicyBillingSummary';
import ContactPhoneDetails from '../gateway/directives/ContactPhoneDirective/ContactPhoneDetails';
import ClaimSummary from '../gateway/directives/ClaimSummaryDirective/ClaimSummary';
import PolicyCommissionsSummary from '../gateway/directives/PolicyCommissionsSummaryDirective';
import CommissionsSummary from '../gateway/directives/CommissionsSummaryDirective';
import GatewayDashboard from './directives/GatewayDashboardDirective/GatewayDashboard';
import AccountSummary from '../gateway/directives/AccountSummaryDirective/AccountSummary';
import Tile from '../gateway/directives/TileDirective/Tile';
import ProducerCodeSelect from '../gateway/directives/ProducerCodeSelectDirective/ProducerCodeSelect';
import AdvancedFilterOption from '../gateway/directives/AdvancedFilterOptionDirective/AdvancedFilterOption';
import ActivitiesView from '../gateway/directives/RefreshActivitiesViewDirective/ActivitiesView';
import NoteView from '../gateway/directives/NoteViewDirective/NoteView';
import ActivitySchedule from '../gateway/directives/ActivityScheduleDirective/ActivitySchedule';
import ReassignActivity from '../gateway/directives/ReassignActivityDirective/ReassignActivity';
import Pagination from '../gateway/directives/PaginationDirective/Pagination';
import ReportFrame from '../gateway/directives/ReportFrame';
import GatewayPaymentLineInfo from './directives/GatewayBillingPaymentLineInfo/GatewayPaymentLineInfo';
import JobUnderwritingIssues from '../gateway/directives/JobUnderwritingIssuesDirective/JobUnderwritingIssues';
import ActivityDateFilter from '../gateway/filters/ActivityDateFilter';
import SupportedLobModules from 'integration/gateway/quoteandbind/SupportedLobModules';
import GatewayDashboardSearch from '../gateway/directives/GatewayDashboardSearchDirective/GatewayDashboardSearchDirective';
import GatewayAccountsTable from '../gateway/directives/AccountsTableDirective/accounts-table.directive';
import GatewayReportProducerCommissionToDate from './directives/GatewayReportProducerCommissionToDateDirective/GatewayReportProducerCommissionToDateDirective';
import ReportStatements from './directives/ReportStatementsDirective';
import PolicyQuoteSummary_PSA from 'customerEdge/gateway/directives/PSAPolicyQuoteSummaryDirective/PolicyQuoteSummary_PSA';
import MiniPolicyChange_PSA from 'customerEdge/gateway/directives/PSAMiniPolicyChangeDirective/MiniPolicyChange_PSA';
import MiniEndorsementService_PSA from 'customerEdge/gateway/directives/PSAMiniPolicyChangeDirective/MiniEndorsementService_PSA';
import EditAccountPSA from '../gateway/directives/EditAccount/EditAccountPSA';
import './billingandpayment/app';
import './claim/app';
import './fnol/common/app';
import './quoteandbind/common/app';
import 'edge/gateway/endorsement/common/app';
import 'edge/gateway/contacts/common/app';
import 'edge/platform/base/module';
import 'edge/platform/widgets/inputs/module';
import 'edge/platform/widgets/table/module';
import 'edge/platform/widgets/documentupload/module';
import 'edge/platform/widgets/datetimepicker/module';
import 'edge/platform/widgets/accordion/module';
import 'edge/platform/widgets/basicinputs/module';
import 'edge/platform/widgets/mediasidebar/module';
import 'edge/platform/widgets/thumblist/module';
import 'portalConfig';
import 'angularRouter';
import 'customerEdge/commonpsa/app';

let inheritedModules = [
    'edge.gateway.billing.app',
    'edge.gateway.fnol.common.app',
    'edge.gateway.claim.app',
    'edge.gateway.quoteandbind.common.app',
    'edge.gateway.endorsement.common.app',
    'edge.gateway.contacts.common.app',
    'portal.config',
    'edge.platform.base',
    'edge.platform.widgets.inputs',
    'edge.platform.widgets.table',
    'edge.platform.widgets.documentupload',
    'edge.platform.widgets.ui.bootstrap.datetimepicker',
    'edge.platform.widgets.ui.bootstrap.accordion',
    'edge.platform.widgets.basicinputs',
    'edge.platform.widgets.ui.bootstrap.accordion',
    'edge.platform.widgets.mediasidebar',
    'edge.platform.widgets.thumblist',
    'edge.commonpsa.app'
];

inheritedModules = inheritedModules.concat(SupportedLobModules);

export default angular.module('edge.gateway.app', inheritedModules)

    .config(['$stateProvider', 'state_plugin_config', 'USER_INFO',
        ($stateProvider, RootStateConfig, USER_INFO) => {
            const states = new GatewayRouteConfig(RootStateConfig, true); // PSA: always producer, never underwriter:  USER_INFO().userType === 'producer');
            _.values(states).forEach((state) => {
                $stateProvider.state(state);
            });
        }])

    .constant('lobConfig', {
        lobs: Features.quoteandbind_lob
    })

    /*
     * These constants are used to limit by createTime when making a paginated call to the backend
     * When they are set to null the backend will return all results, otherwise it will apply a date filter
     * and only return those entities what fall within the created time specified below.
     */
    .constant('gatewayParamConfig', {
        jobsCreatedInLastXDays: 30,
        claimsCreatedInLastXDays: null,
        accountsCreatedInLastXDays: null,
        policiesCreatedInLastXDays: 90,
        accountLandingResultsPerPage: 25,
        claimsLandingResultsPerPage: 25,
        cpPropertiesPerPage: 50
    })

    .filter('gwActivityDateFilter', ActivityDateFilter)

    .directive('gwActivitySummary', ActivitySummary)
    .directive('gwNotesList', GatewayNotes)
    .directive('gwDocumentsList', GatewayDocuments)
    .directive('gwBackButton', BackButton)
    .directive('gwJobSummary', JobSummary)
    .directive('gwAddActivity', AddActivity)
    .directive('gwPolicySummary', PolicySummary)
    .directive('gwReassignActivity', ReassignActivity)
    .directive('gwPolicyTransactionsSummary', PolicyTransactions)
    .directive('gwCancelPolicy', CancelPolicy)
    .directive('gwChangePolicy', ChangePolicy)
    .directive('gwPolicyBillingSummary', PolicyBillingSummary)
    .directive('gwContactPhoneDetails', ContactPhoneDetails)
    .directive('gwClaimSummary', ClaimSummary)
    .directive('gwGatewayDashboard', GatewayDashboard)
    .directive('gwAccountSummary', AccountSummary)
    .directive('gwTile', Tile)
    .directive('gwProducerCodeSelect', ProducerCodeSelect)
    .directive('gwAdvancedFilterOption', AdvancedFilterOption)
    .directive('gwActivitiesView', ActivitiesView)
    .directive('gwNoteView', NoteView)
    .directive('gwActivitySchedule', ActivitySchedule)
    .directive('gwPagination', Pagination)
    .directive('gwGatewayReport', ReportFrame)
    .directive('gwGatewayBillingPaymentLineInfo', GatewayPaymentLineInfo)
    .directive('gwJobUnderwritingIssues', JobUnderwritingIssues)
    .directive('gwGatewayDashboardSearch', GatewayDashboardSearch)
    .directive('gwAccountsTable', GatewayAccountsTable)
    .directive('gwReportProducerCommissionToDate', () => new GatewayReportProducerCommissionToDate())

    .directive('psaPolicyQuoteSummary', PolicyQuoteSummary_PSA)
    .directive('psaMiniPolicyChange', MiniPolicyChange_PSA)
    .directive('gwEditAccountPsa', EditAccountPSA)
    .factory('MiniEndorsementService_PSA', MiniEndorsementService_PSA)

    .factory('AccountService', AccountService)
    .factory('CommissionService', CommissionService)
    .factory('SubmissionService', SubmissionService)
    .factory('RenewalService', RenewalService)
    .factory('ActivityService', ActivityService)
    .factory('PolicyService', PolicyService)
    .factory('SearchService', SearchService)
    .factory('JobService', JobService)
    .factory('UserService', UserService)
    .factory('OrganizationService', OrganizationService)
    .factory('ProductService', ProductService)
    .factory('DocumentService', DocumentService)
    .factory('CancellationService', CancellationService)
    .factory('NewAccountService', NewAccountService)
    .factory('ServiceBoxInfoService', ServiceBoxInfoService)
    .factory('ContactService', ContactService)
    .factory('PolicyChangeService', PolicyChangeService)

    .component('gwCommissionsSummary', CommissionsSummary)
    .component('gwPolicyCommissionsSummary', PolicyCommissionsSummary)
    .component('gwReportStatements', ReportStatements);

